var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatelib(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45.000000pt",
    height: "45.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170 338 c0 -13 5 -29 12 -36 16 -16 110 -16 126 0 16 16 16 61 0 55 -7 -2 -13 -16 -13 -30 1 -14 -3 -23 -7 -21 -4 3 -8 12 -8 20 0 9 -11 14 -35 14 -24 0 -35 -5 -35 -14 0 -8 -4 -17 -8 -20 -4 -2 -8 7 -7 21 0 14 -6 28 -12 30 -8 3 -13 -4 -13 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137 333 c-4 -3 -7 -53 -7 -110 l0 -103 110 0 110 0 0 104 c0 59 -4 108 -10 111 -11 7 -13 -10 -10 -112 l2 -73 -91 0 -91 0 0 70 c0 39 4 70 9 70 4 0 6 11 3 25 -4 25 -13 31 -25 18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170 260 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210 260 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250 260 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290 260 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170 215 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210 215 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250 215 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290 215 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170 175 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210 175 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250 175 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatelib);
export default __webpack_public_path__ + "static/media/datelib.07a57cf162dc1b2f73ff6f163f177a1e.svg";
export { ForwardRef as ReactComponent };